import React from "react";
import '../../styles/Styles.css'

const Heading = () => {
  return (
    <div id="contentbox">
        <div className="email-settings-section">
        <h1 className="email-settings-heading">RETRIEVE YOUR EMAIL SETTINGS</h1>
          <p className="email-settings-description">
          Easily access IMAP, POP3, and SMTP settings for any domain. Determine whether the domain is hosted with us or a third-party provider and get precise email configuration details.
          </p>
        </div>
    </div>
    
  );
};

export default Heading;